import { render, staticRenderFns } from "./centurion-luxury.vue?vue&type=template&id=001351ba&scoped=true&"
import script from "./centurion-luxury.vue?vue&type=script&lang=js&"
export * from "./centurion-luxury.vue?vue&type=script&lang=js&"
import style0 from "./centurion-luxury.vue?vue&type=style&index=0&id=001351ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001351ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
